import React from 'react';

const Quote = () => (
  <div className="quote__container">
    <div className="card">
      <p className="quote__text">Mathematics is not about numbers, equations, computations, or algorithms: It is about understanding.</p>
      <p className="quote__author">William Paul Thurston</p>
    </div>
  </div>
);

export default Quote;
